import { parse } from "query-string";
import { getSingularOrgListName } from "utils";

const useListTitle = (listName) => {
  const { name, org } = parse(window.location.search);

  if (name && org) {
    return {
      fullListName: `List of ${listName} in ${name}`,
    };
  }

  return {
    fullListName: `List of ${listName}`,
  };
};

export { useListTitle };

